// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';


class DeleteFixture extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      data_uploaded: false,
      data_error: false,
      dependency_details: "",
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }


  componentDidMount() {
     const url = `${getLocationOrigin()}/eagleeye/${this.state.id}/get_details_for_delete_fixture/`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ dependency_details: data.details }))
       .catch(error => error);
  }

  postDeletedFixture(data, props) {
    const url = `${getLocationOrigin()}/eagleeye/${this.state.id}/delete_fixture/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}

    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  handleSubmit(event) {
    event.preventDefault();
    console.log('Submit');
    this.postDeletedFixture(this.state.id, this.props);
    console.log('post');
    console.log(this.state);
  }

  render() {
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12 label_blue_1">
            Delete Fixture
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
            <div style={styles.items} className="col-md-12">
              <div>
                Dependencies in {this.state.dependency_details}. Are you sure?
              </div>
            </div>
            <div style={styles.button_submit} className="col-md-12">
              <input className="button1" type="submit" value="Submit"/>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default DeleteFixture;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/deleteFixture/index.js